import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

interface SuccessMessageComponentProps {
    showSuccess?: boolean;
    message?: string;
    compact?: boolean;
}

const SuccessMessageComponent: React.FC<SuccessMessageComponentProps> = ({
    showSuccess = true,
    message = "Scoring complete!",
    compact = false,
}) => {
    const successMessage = message;

    if (!showSuccess) return null;

    return (
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: compact ? 1 : 2, py: compact ? 1 : 4, px: compact ? 1 : 4, textAlign: "center" }}>
            <Typography variant="h6">{successMessage}</Typography>
            <Box component="img" src="/check-icon.png" alt="Success" sx={{ width: compact ? 40 : 64, height: compact ? 40 : 64 }} />
        </Box>
    );
};

export default SuccessMessageComponent;